import { MarketsFilter, SourceFilter } from '@toggle/toggle';

import { create } from '../create-store/createStore';

export const BENZINGA = 'benzinga';

export type MarketsToCheck = MarketsFilter & {
  isChecked: boolean;
};
export type SourcesToCheck = SourceFilter & {
  isChecked: boolean;
};

interface InitializeProps {
  markets: MarketsFilter[];
  sources: SourceFilter[];
}

type State = {
  marketsToCheck: MarketsToCheck[];
  sourcesToCheck: SourcesToCheck[];
  isFetchingMostRead: boolean;
  dateRangeEnd?: string;
};

type Actions = {
  initialize: ({ markets, sources }: InitializeProps) => void;
  marketToggleSelectAll: (prevIsChecked: boolean) => void;
  marketToggleSelectOne: (marketKey: string) => void;
  sourcesToggleSelectAll: (prevIsChecked: boolean) => void;
  sourcesToggleSelectOne: (marketKey: string) => void;
  toggleIsFetchingMostRead: (prevValue: boolean) => void;
  resetMostRead: () => void;
  handleSetDateRange: (dateTo?: string) => void;
  resetDateRange: () => void;
};

type NewsFiltersStore = State & Actions;

export const useNewsFiltersStore = create<NewsFiltersStore>((set, get) => ({
  marketsToCheck: [],
  sourcesToCheck: [],
  isFetchingMostRead: false,
  initialize: ({ markets, sources }: InitializeProps) => {
    set({
      marketsToCheck: markets
        .filter(market => market.featured)
        .map(market => {
          return { ...market, isChecked: false };
        }),
      sourcesToCheck: sources.map(source => ({
        ...source,
        isChecked: false,
      })),
    });
  },
  marketToggleSelectAll: (prevIsChecked: boolean) => {
    set(({ marketsToCheck }) => ({
      marketsToCheck: marketsToCheck.map(item => {
        return { ...item, isChecked: !prevIsChecked };
      }),
    }));
  },
  marketToggleSelectOne: (key: string) => {
    set(() => ({
      marketsToCheck: get().marketsToCheck.map(item => {
        if (item.key === key) {
          return { ...item, isChecked: !item.isChecked };
        } else {
          return { ...item };
        }
      }),
    }));
  },
  sourcesToggleSelectAll: (prevIsChecked: boolean) => {
    set(({ sourcesToCheck }) => ({
      sourcesToCheck: sourcesToCheck.map(item => {
        return { ...item, isChecked: !prevIsChecked };
      }),
    }));
  },
  sourcesToggleSelectOne: (key: string) => {
    set(({ sourcesToCheck }) => ({
      sourcesToCheck: sourcesToCheck.map(item => {
        if (item.key === key) {
          return { ...item, isChecked: !item.isChecked };
        } else {
          return { ...item };
        }
      }),
    }));
  },
  toggleIsFetchingMostRead: (prevValue: boolean) => {
    set({
      isFetchingMostRead: prevValue,
    });
  },
  resetMostRead: () => {
    set({
      isFetchingMostRead: false,
    });
  },
  handleSetDateRange: (dateTo?: string) => {
    set({
      dateRangeEnd: dateTo ? dateTo : new Date().toISOString(),
    });
  },
  resetDateRange: () => {
    set({
      dateRangeEnd: undefined,
    });
  },
}));
